import fieldsHelper from '../utils/fieldsHelper';
import formHelper from '../utils/formHelper';
import visibility from '../visibility';
import layoutVisitor from '../layout/layoutVisitor';
/**
 * Calculate visibility for changed fields
 * @param {Array<import("../logic/types").EcrionFormField>} fields Changed fields that triggers the visibility
 * @param {import("../logic/types").EcrionFormState} state
 * @returns {boolean} if at leas one visibility changed for and a relayout must be performed
 */

var calculateFieldsVisibilities = function calculateFieldsVisibilities(fields, state) {
  var recalculateLayout = false;
  fields.forEach(function (f) {
    if (!f) return;
    if (calculateVisibilitiesTriggeredBy(f, state)) recalculateLayout = true;
  });
  return recalculateLayout;
};
/**
 * Calculate visibility for changed field
 * @param {import("../logic/types").EcrionFormField} field Changed field that triggers the visibility
 * @param {import("../logic/types").EcrionFormState} state
 * @returns {boolean} if at leas one visibility changed for and a relayout must be performed
 */


var calculateVisibilitiesTriggeredBy = function calculateVisibilitiesTriggeredBy(field, state) {
  // detect ids of all fields with the vibility dependent on specified field
  var dependencies = state.visibility.mapping[field.originalId || field.id];
  if (!dependencies || !dependencies.length) return;
  var recalculateLayout = false; // for each dependent field, calculate if has cloned field in the same repeating context as current field

  dependencies.forEach(function (fieldId) {
    if (!state.visibility.conditions[fieldId]) return;
    var fields = fieldsHelper.findClonedFieldsInSameRepeatingContext(state, state.fields[fieldId], field);
    fields.forEach(function (f) {
      recalculateLayout = true; // recalculate the visibility for this field

      var isVisible = visibility.calculate(f.id, state);
      formHelper.setMetaProp(state, f.id, 'hidden', !isVisible);
    });
  });
  return recalculateLayout;
};
/**
 * Check if the repeating field does not contains any fields
 * @param {import('../logic/types').EcrionFormRepeatingField} repeating
 */


var isEmptyRepeating = function isEmptyRepeating(repeating) {
  return !repeating.children || repeating.children.length === 0;
};
/**
 * Check if form doesn't contains visible input fields
 * @param {import("../logic/types").EcrionFormState} state
 * @returns {boolean}
 */


var hasVisibleInputFields = function hasVisibleInputFields(state) {
  var hasVisibleFields = false;
  var invisibleFieldsTypes = ['script', 'xmlfield', 'label', 'datagroup', 'separator'];
  layoutVisitor.visit(state, function (field) {
    if (invisibleFieldsTypes.includes(field.type)) return false;
    if (field.type === 'repeating' && isEmptyRepeating(field)) return false;
    var isVisible = !state.meta[field.id] || !state.meta[field.id].hidden;
    hasVisibleFields = hasVisibleFields || isVisible;
  });
  return hasVisibleFields;
};

export default {
  calculate: calculateFieldsVisibilities,
  hasVisibleInputFields: hasVisibleInputFields
};